// Per-user traffic isolation: every user-facing string in one place, verbatim from
// docs/sdlc/per-user-traffic-isolation/20-requirements.md "UI copy for unsupported paths".
// Tests pin these; change the requirements doc first, then here.

export const EMPTY_STATE_COPY =
  'No traffic from your devices yet. Connect a device from Connect Device to start capturing. ' +
  'If you captured here before, re-enroll your device there; earlier traffic from the old shared setup ' +
  'is not assigned to anyone and is not shown. Traffic from other users\' devices is never shown here.';

export const UNOWNED_DEVICE_COPY =
  'This device is still using the old shared setup, so its traffic is not assigned to you. ' +
  'Re-enroll it from Connect Device to see it here.';

export const TAKEOVER_PREVIOUS_COPY = (deviceLabel) =>
  `Another account enrolled a device on the same network address as ${deviceLabel || 'your device'}. ` +
  'Traffic from that address is no longer assigned to you. Re-enroll to take it back.';

export const TAKEOVER_NEW_COPY =
  'This network address was previously assigned to another account. It is now yours. Their device has been notified.';

export const STATIC_TOKEN_TAP_COPY =
  'This USB capture used a shared script token, so its rows are not assigned to you and you will not see them here. ' +
  'Start capture from Connect Device to own them.';

export const MIXED_OWNERS_COPY =
  'This run contains traffic from more than one account, so it can\'t be signed off. Re-run scoped to one owner.';

export const SHARE_OFF_COPY = 'Private: only you';
export const SHARE_ON_COPY =
  'Shared: anyone signed in can open this HAR and see everything in it, including request and response bodies, advertising IDs and consent strings.';

/** Sign-off report excluded rows (AC 123). '' when n is not a positive number. */
export function excludedRowsCopy(n) {
  const k = Math.floor(Number(n));
  if (!Number.isFinite(k) || k <= 0) return '';
  return `${k} unowned rows from your devices were excluded from this report. Re-enroll the device from Connect Device to include new traffic.`;
}

/**
 * Takeover message -> { role, text } for the banner, or null for a shape we do not know.
 * Wire shape (proxy-server/enrollments.js): { type:'ip_takeover', ip, role:'previous'|'new', deviceLabel, at }.
 */
export function takeoverNotice(msg) {
  if (!msg || msg.type !== 'ip_takeover') return null;
  if (msg.role === 'previous') return { role: 'previous', ip: msg.ip || '', at: msg.at || null, text: TAKEOVER_PREVIOUS_COPY(msg.deviceLabel) };
  if (msg.role === 'new') return { role: 'new', ip: msg.ip || '', at: msg.at || null, text: TAKEOVER_NEW_COPY };
  return null;
}

/**
 * Parse the secret-bearing result of POST /proxy/enroll for a logcat tap:
 * { id, secret } -> 'id:secret' (the --enrollment / X-Enrollment value) or ''.
 */
export function enrollmentCredential(resp) {
  if (!resp || typeof resp.id !== 'string' || typeof resp.secret !== 'string' || !resp.id || !resp.secret) return '';
  return `${resp.id}:${resp.secret}`;
}
